import { formatBalanceNumber } from "../../communication/format";

import React, { useContext } from "react";
import { taskClaim } from "../../communication/communication";
import { ReloadTasksContext } from "./TasksView";
import { useTranslation } from "react-i18next";
import { NotificationsContext } from "../../App";
import { Button } from "../Common/Elements/Button";

const doNothing = () => { }

export function ClaimTasksButton({ amount }: { amount: number }) {
    const addNotification = useContext(NotificationsContext);
    const reloadTasks = useContext(ReloadTasksContext);
    const { t } = useTranslation()

    const claimTasks = () => {
        taskClaim()
            .then(r => addNotification(`+ ${formatBalanceNumber(r.data!.claim_value)} Test Credits`))
            .then(_ => reloadTasks())
    }

    const nothing = t("nothingToClaim")
    const claimText = `${t("claim")} ${formatBalanceNumber(amount)} Test Credits`

    return <Button
        backgroundColor={amount > 0 ? "var(--color-main)" : "#1e1e22"}
        onClick={amount > 0 ? claimTasks : doNothing}
        textColor={amount > 0 ? "black" : "var(--font-dim)"}
        text={amount > 0 ? claimText : nothing}
    />
}